import Vue from 'vue'
import Vuex from 'vuex'
import _axios from '@/ws/domain.js';
import urls from '@/ws/api.js';
import commonMethods from '@/common/common-methods/commonMethods.js';

Vue.use(Vuex);

const state = {
    // 登录设备：移动端true, pc端false
    isMobile: false,
    // ios端
    isiOS: false,
    // 是否登录
    isLogin: false,
    // 默认头像
    defaultAvatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
    uploadHeader: {
        Authorization: window.localStorage.getItem('token') ? 'Bearer' + window.localStorage.getItem('token') : 'Bearer'
    }, // 上传请求头
    // 头部菜单导航选中项
    headerNavIndex: 0,
    // 头部搜索框控制
    headerSearchShow: true,
    // 用户信息
    userInfo: {},
    // 栏目列表数据
    columnList: [],
    // 角色列表数据
    roleList: [],
    // 首页二维码
    homeQrCode: '',
    // 左侧导航菜单
    childColumnList: [],
    // 左侧导航菜单选中项
    leftMenuIndex: -1,
    // 左侧栏目菜单组件所需参数
    leftMenuParams: {
        column_bgimg: '', // 栏目背景图
        columnId: null, // 一级栏目id
        columnName: '', // 一级栏目名称
        menuList: [] // 一级栏目的子级栏目
    },
    // 当前所在栏目
    nowColumnParams: {
        columnId: null, // 栏目id
        columnName: '', // 栏目名称
        columnInfo: '', // 栏目简介
        qrcode: '', // 栏目二维码
        isFollow: false // 栏目是否已关注
    },
    // 四级菜单栏
    fourthColumnList: [],
    // 首页广告位文章
    homeAdvArticles: { one: {}, tow: {}, three: {}, four: {} },
    // 栏目文章列表数据
    columnArticleData: {
        articleOne: {},
        articleTow: {},
        articleThree: {},
        list: [],
        total: 0
    },
    // 右侧文章模块数据
    articleModules: {
        mpwxTrusteeshipList: [], // 栏目托管公众号
        quickList: [], // 推荐快报
        hotList: [], // 热门文章
        hotTranspondList: [], // 热门转发
        transRecomList: [], // 转发推荐
        videoList: [] // 视频区
    },
    // 栏目广告位文章
    advArticleList: [],
    // 用户-左侧菜单选中状态
    userLeftStatus: {
        menuIndex: 0, // 第一级菜单选中项
        childIndex: -1 // 第二级菜单选中项
    },
    // 文章详情面包屑导航数据
    breadcrumbList: [],
    headerShow: true,
    // 佣金详情数据
    commissionData: {
        all_commission_amount: 0, // 佣金总额
        all_order_amount: 0, // 成交金额
        cumulative_commission_amount: 0, // 累计佣金
        withdrawable_amount: 0, // 可提现
        withdrawn_amount: 0 // 已提现
    }
}
const mutations = {
    /**
     * @function setEquipmentInfo 设置登录端信息
     * @param {*} state 
     * @param {*} res 
     */
    setEquipmentInfo(state, res) {
        state.isMobile = res.isMobile;
        state.isiOS = res.isiOS;
        window.sessionStorage.setItem("setEquipmentInfo", JSON.stringify(res));
    },
    /**
     * @function setLoginStatus 设置登录状态
     * @param {*} state 
     * @param {*} res 
     */
    setLoginStatus(state, res) {
        state.isLogin = res;
        window.sessionStorage.setItem('isLogin', JSON.stringify({isLogin: res}));
    },
    /**
     * @function setColumnList 设置栏目列表数据
     * @param {*} state 
     * @param {*} res 
     */
    setColumnList(state, res) {
        state.columnList = res;
        state.homeQrCode = res[0].qrcode_path;
        window.sessionStorage.setItem('columnList', JSON.stringify(res));
    },
    /**
     * @function setRoleList 设置角色列表数据
     * @param {*} state 
     * @param {*} res 
     */
    setRoleList(state, res) {
        state.roleList = res;
        window.sessionStorage.setItem('roleList', JSON.stringify(res));
    },
    /**
     * @function setNavIndex 设置导航菜单选中项
     * @param {*} state 
     * @param {*} res 
     */
    setNavIndex(state, res) {
        state.headerNavIndex = res;
        let nowColumn = state.columnList[res];
        if(res != 0) {
            state.childColumnList = nowColumn.children ? nowColumn.children : [];
            window.sessionStorage.setItem('childColumnList', JSON.stringify(state.childColumnList));
        }
        state.nowColumnParams = {
            columnId: nowColumn.id,
            columnName: nowColumn.name,
            columnInfo: nowColumn.about,
            qrcode: nowColumn.qrcode_path,
            isFollow: nowColumn.isfollowcolumn
        };
        state.leftMenuParams.columnId = nowColumn.id;
        state.leftMenuParams.columnName = nowColumn.name;
        state.nowColumnParams.isFollow = nowColumn.isfollowcolumn;
        window.sessionStorage.setItem('navStatus', JSON.stringify({index: res}));
    },
    /**
     * @function setHeadSearchShow 设置头部搜索框控制参数
     * @param {*} state 
     * @param {*} res 
     */
    setHeadSearchShow(state, res) {
        state.headerSearchShow = res;
        // window.sessionStorage.setItem('headerSearchShow', JSON.stringify({isShow: res}));
    },
    /**
     * @function setLeftMenuParams 设置左侧栏目菜单组件所需参数
     * @param {*} state 
     * @param {*} res 
     */
    setLeftMenuParams(state, res) {
        state.leftMenuIndex = res;
        if(res >= 0) {
            let nowColumn = null;
            let timer = setInterval(() => {
                nowColumn = state.childColumnList[res];
                if(nowColumn) {
                    clearInterval(timer);
                    state.nowColumnParams.columnId = nowColumn.id;
                    state.nowColumnParams.columnName = nowColumn.name;
                    state.nowColumnParams.columnInfo = nowColumn.about;
                    state.nowColumnParams.qrcode = nowColumn.qrcode_path;
                    state.nowColumnParams.isFollow = nowColumn.isfollowcolumn;
                }
            }, 10);
        }
        window.sessionStorage.setItem('leftMenuIndex', JSON.stringify({index: res}));
    },
    /**
     * @function setLeftMenuBgimg 设置左侧栏目背景图
     * @param {*} state 
     * @param {*} res 
     */
    setLeftMenuBgimg(state, res) {
        switch (res) {
            case 6:
                state.leftMenuParams.column_bgimg = 'http://cdn.bigbays.cn/pc/column/column-bgimg1.png';
                break;
            case 7:
                state.leftMenuParams.column_bgimg = 'http://cdn.bigbays.cn/pc/column/column-bgimg2.png';
                break;
            case 8:
                state.leftMenuParams.column_bgimg = 'http://cdn.bigbays.cn/pc/column/column-bgimg3.png';
                break;
            case 60:
                state.leftMenuParams.column_bgimg = 'http://cdn.bigbays.cn/pc/column/column-bgimg4.png';
                break;
            default:
                break;
        }
    },
    /**
     * @function setChildColumn 设置pc端左侧栏目数据
     * @param {*} state 
     * @param {*} res 
     */
    setChildColumn(state, res) {
        state.childColumnList = res;
        window.sessionStorage.setItem('childColumnList', JSON.stringify(res));
    },
    /**
     * @function setNowColumnId 设置当前所在栏目
     * @param {*} state 
     * @param {*} res 
     */
    setNowColumnParams(state, res) {
        state.nowColumnParams.columnId = res.columnId;
        state.nowColumnParams.columnName = res.columnName;
        state.nowColumnParams.columnInfo = res.columnInfo;
        state.nowColumnParams.qrcode = res.qrcode;
        state.nowColumnParams.isfollow = res.isfollow;
        let item = {
            columnId: res.columnId,
            columnName: res.columnName,
            columnInfo: res.columnInfo,
            qrcode: res.qrcode,
            isfollow: res.isfollow
        };
        window.sessionStorage.setItem('nowColumnParams', JSON.stringify(item));
    },
    /**
     * @function setFourthColumn 设置四级菜单栏目数据
     * @param {*} state 
     * @param {*} res 
     */
    setFourthColumn(state, res) {
        appModule.state.fourthColumnList = res;
        window.sessionStorage.setItem('fourthColumnList', JSON.stringify(res));
    },
    /**
     * @function setColumnArticleData 设置栏目文章数据
     * @param {*} state 
     * @param {*} res 
     */
    setColumnArticleData(state, res) {
        appModule.state.columnArticleData.list = res.list;
        appModule.state.columnArticleData.total = res.total;
    },
    /**
     * @function setColumnAdvArticles 设置栏目广告位文章
     * @param {*} state 
     * @param {*} res 
     */
    setColumnAdvArticles(state, res) {
        state.advArticleList = res;
    },
    /**
     * @function setUserInfo 设置用户信息
     * @param {*} state 
     * @param {*} res 
     */
    setUserInfo(state, res) {
        state.userInfo = res;
        window.sessionStorage.setItem('userInfo', JSON.stringify(res));
    },
    /**
     * @function setUserLeftStatus 设置用户左侧菜单选中状态
     * @param {*} state 
     * @param {*} res 
     */
    setUserLeftStatus(state, res) {
        state.userLeftStatus = res;
        window.sessionStorage.setItem('userLeftStatus', JSON.stringify(res));
    },
    /**
     * @function setBreadcrumbList 设置文章详情面包屑导航数据
     * @param {*} state 
     * @param {*} res 
     */
    setBreadcrumbList(state, res) {
        state.breadcrumbList = res;
        window.sessionStorage.setItem('breadcrumb', JSON.stringify(res));
    },
    goods(state, res) {
        state.headerShow = res;
    }
}
const actions = {
    /**
     * @function getUserInfo 获取用户信息
     * @param {*} context 
     * @param {*} payload 
     */
    getUserInfo(context, payload) {
        state.isLogin = true;
        _axios.get(urls.userInfo).then(res => {
            let data = res.data.result;
            if(data && data.avatar) {
              // 用户头像路径补全处理
              data.avatar = commonMethods.jointPicUrl(data.avatar);
            }
            state.userInfo = data;
            window.sessionStorage.setItem('userInfo', JSON.stringify(data));
        });
    },
    /**
     * @function getArticleList 获取文章列表数据
     * @param {*} context 
     * @param {*} payload 
     */
    getArticleList(context, payload) {
        let sendData = {
            column_id: payload.column_id,
            limit: payload.params.limit,
            page: payload.params.page
        };
        _axios.get(urls.articleList, { params: sendData }).then(res => {
            let result = res.data.result, data = result.data;
            if(data.length > 0) {
                for(let i = 0; i < data.length; i++) {
                    if(data[i].cover) {
                        data[i].cover = commonMethods.jointPicUrl(data[i].cover);
                    }
                    if(data[i].created_at) {
                        data[i].created_at = String(data[i].created_at).split(' ')[0];
                    }
                }
            }
            state.columnArticleData.list = payload.flag || payload.params.page > 1 ? state.columnArticleData.list.concat(data) : data;
            state.columnArticleData.total = result.total;
            window.sessionStorage.setItem('_PAGE_'+sendData.column_id+'_', sendData.page);
        });
    },
    /**
     * @function getAdvArticles 获取广告位文章
     * @param {*} context 
     * @param {*} payload 
     */
    getAdvArticles(context, payload) {
        _axios.get(urls.advArticleList, {
            params: { column_id: payload.column_id, limit: 20, page: 1 }
        }).then(res => {
            let data = res.data.result;
            state.advArticleList = res.data.result;
            if(data.length > 0) {
                data.forEach(el => {
                    let article = null;
                    if(el.articleslist.length > 0) {
                        el.articleslist.forEach((art, i) => {
                            if(art.article && art.article.cover) {
                                art.article.cover = commonMethods.jointPicUrl(art.article.cover);
                            }
                            if(art.article && art.article.created_at) {
                                art.article.created_at = String(art.article.created_at).split(' ')[0];
                            }
                            if(i == 0) {
                                article = art.article;
                            }
                        });
                    }
                    switch (el.name) {
                        case '首页广告区1':
                            state.homeAdvArticles.one = article;
                            break;
                        case '首页广告区2':
                            state.homeAdvArticles.tow = article;
                            break;
                        case '首页广告区3':
                            state.homeAdvArticles.three = article;
                            break;
                        case '首页广告区4':
                            state.homeAdvArticles.four = article;
                            break;
                        case '文章列表广告位1':
                            state.columnArticleData.articleOne = article;
                            break;
                        case '文章列表广告位2':
                            state.columnArticleData.articleTow = article;
                            break;
                        case '文章列表广告位3':
                            state.columnArticleData.articleThree = article;
                            break;
                        case '热门文章':
                            state.articleModules.hotList = el.articleslist;
                            if(el.articleslist.length < 20) {
                                _axios.get(urls.advArticleList, {
                                    params: {
                                        column_id: payload.column_id,
                                        position: 'right',
                                        cate: 'hotarticles',
                                        limit: 20 - el.articleslist.length,
                                        page: 1
                                    }
                                }).then(ress => {
                                    let hot = ress.data.result;
                                    if(hot.length > 0) {
                                        let hotList = [];
                                        hot.forEach(fw => {
                                            if(fw.cover) {
                                                fw.cover = commonMethods.jointPicUrl(fw.cover);
                                            }
                                            if(fw.created_at) {
                                                fw.created_at = String(fw.created_at).split(' ')[0];
                                            }
                                            hotList.push({ article: fw });
                                        });
                                        state.articleModules.hotList = state.articleModules.hotList.concat(hotList);
                                    }
                                });
                            }
                            break;
                        case '热门转发':
                            state.articleModules.hotTranspondList = el.articleslist;
                            if(el.articleslist.length < 20) {
                                _axios.get(urls.advArticleList, {
                                    params: {
                                        column_id: payload.column_id,
                                        position: 'right',
                                        cate: 'hotforwarding',
                                        limit: 20 - el.articleslist.length,
                                        page: 1
                                    }
                                }).then(ress => {
                                    let forward = ress.data.result;
                                    if(forward.length > 0) {
                                        let forwardList = [];
                                        forward.forEach(fw => {
                                            if(fw.cover) {
                                                fw.cover = commonMethods.jointPicUrl(fw.cover);
                                            }
                                            if(fw.created_at) {
                                                fw.created_at = String(fw.created_at).split(' ')[0];
                                            }
                                            forwardList.push({ article: fw });
                                        });
                                        state.articleModules.hotTranspondList = state.articleModules.hotTranspondList.concat(forwardList);
                                    }
                                });
                            }
                            break;
                        case '转发推荐':
                            state.articleModules.transRecomList = el.articleslist;
                            if(el.articleslist.length < 20) {
                                _axios.get(urls.advArticleList, {
                                    params: {
                                        column_id: payload.column_id,
                                        position: 'right',
                                        cate: 'hotrecommend',
                                        limit: 20 - el.articleslist.length,
                                        page: 1
                                    }
                                }).then(ress => {
                                    let forward = ress.data.result;
                                    if(forward.length > 0) {
                                        let forwardList = [];
                                        forward.forEach(fw => {
                                            if(fw.cover) {
                                                fw.cover = commonMethods.jointPicUrl(fw.cover);
                                            }
                                            if(fw.created_at) {
                                                fw.created_at = String(fw.created_at).split(' ')[0];
                                            }
                                            forwardList.push({ article: fw });
                                        });
                                        state.articleModules.transRecomList = state.articleModules.transRecomList.concat(forwardList);
                                    }
                                });
                            }
                            break;
                        default:
                            break;
                    }
                });
            }
        });
    },
    /**
     * @function getMpwxTrusteeshipList 获取栏目托管公众号
     * @param {*} context 
     * @param {*} payload 
     */
    getMpwxTrusteeshipList(context, payload) {
        _axios.get(urls.mpwxTrusteeshipList, {
            params: { column_id: payload.column_id }
        }).then(res => {
            let data = res.data.result.data;
            state.articleModules.mpwxTrusteeshipList = data;
        });
    },
    /**
     * @function getCommissionDetail 获取佣金详情
     * @param {*} context 
     * @param {*} payload
     */
    getCommissionDetail(context, payload) {
        _axios.get(urls.commissionDetail).then(res => {
            let data = res.data.result;
            state.commissionData = data;
        });
    },
}
const pcModule = {
    state, mutations
}
const appModule = {
    state, mutations
}
export const store = new Vuex.Store({
    state,
    mutations,
    actions,
    modules: {
        pc: pcModule,
        app: appModule
    }
});


// WEBPACK FOOTER //
// ./src/vuex/store.js